export const FETCH_USER = 'fatch_user';
export const EMAIL = 'email';



// WEBPACK FOOTER //
// ./src/actions/types.js